import { request } from "@/api/client";

export type OrgMemberSummary = {
  user_id: string;
  name?: string | null;
  email?: string | null;
  role: string;
  can_view_financials: boolean;
  created_at: string;
};

export function listOrgMembers() {
  return request<OrgMemberSummary[]>("/auth/org/members");
}

export function updateOrgMember(userId: string, payload: { can_view_financials: boolean }) {
  return request<OrgMemberSummary>(`/auth/org/members/${encodeURIComponent(userId)}`, {
    method: "PATCH",
    body: payload,
  });
}
